import { Flex, PseudoBox, Text } from '@chakra-ui/core'
import { AiAvatar } from 'components/CommonComponents/AIAvatar'
import { Volume2, VolumeX, X } from 'lucide-react'
import React from 'react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

const AI_AVATAR_SIZE = 130 as const

interface IProps {
  onClose: () => void
  title: string
  isInstantConversation?: boolean
  setIsPlaying: (isPlaying: boolean) => void
  isPlaying: boolean
}

export const ConversationHeader = ({
  onClose,
  title,
  isInstantConversation = false,
  setIsPlaying,
  isPlaying,
}: IProps) => {
  const isRtl = useSelector(isRtlSelector)
  return (
    <Flex alignItems="center" justifyContent="center" position="relative">
      <PseudoBox
        onClick={() => setIsPlaying(!isPlaying)}
        cursor="pointer"
        position="absolute"
        right={isRtl ? 'unset' : '40px'}
        left={isRtl ? '40px' : 'unset'}
        top="5px"
      >
        {isPlaying ? <Volume2 size={24} /> : <VolumeX size={24} />}
      </PseudoBox>
      <PseudoBox
        onClick={onClose}
        cursor="pointer"
        position="absolute"
        right={isRtl ? 'unset' : '0px'}
        left={isRtl ? '0px' : 'unset'}
        top="5px"
      >
        <X size={24} />
      </PseudoBox>
      {isInstantConversation ? (
        <Flex
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          pos="absolute"
          top="-10px"
          left="50%"
          transform="translate(-50%, -50%)"
          w="100px"
          h="100px"
          bg="white"
          borderRadius="50%"
        >
          <AiAvatar listening={true} size={AI_AVATAR_SIZE as number} />
        </Flex>
      ) : (
        <Text fontWeight="bold">{title}</Text>
      )}
    </Flex>
  )
}
